<template>
  <div>
    <h3>
      Membership Groups
      <span v-text="`(${selectedGroupUuids.length})`" />
    </h3>
    <div class="flex justify-center items-baseline mt-4">
      <div class="input-group flex-1">
        <input
          v-model="search"
          type="text"
          class="recipientFilter"
          placeholder="Filter membership groups"
        >
      </div>
      <div class="text-xs pl-4">
        <a
          href="#"
          @click.prevent="selectAll"
          v-text="'Select All'"
        />
        <span
          class="mx-2"
          v-text="' | '"
        />
        <a
          href="#"
          @click.prevent="selectNone"
          v-text="'Select None'"
        />
      </div>
    </div>
    <ul
      v-show="membershipGroups.length"
      ref="recipientGroupContainer"
      class="scroll-checklist scroll-blue"
    >
      <li
        v-for="group in membershipGroups"
        :key="group.uuid"
      >
        <input
          :id="group.uuid"
          v-model="selectedGroups"
          type="checkbox"
          :name="group.uuid"
          :value="group.uuid"
        >
        <label
          :for="group.uuid"
          class="checkbox"
          v-text="group.attributes.title"
        />
      </li>
    </ul>
    <ul
      v-show="membershipGroups.length == 0"
      class="list-reset"
    >
      <li>
        <small>No results for "{{ search }}"</small>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RecipientGroupSelector',
  model: {
    prop: 'selectedGroupUuids',
  },
  props: {
    selectedGroupUuids: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedGroups: [],
      search: '',
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data,
      pagination: state => state.membership.membershipGroups.meta.pagination,
    }),
  },
  watch: {
    selectedGroupUuids(newVal) {
      if (newVal !== this.selectedGroups) {
        this.selectedGroups = newVal
      }
    },
    selectedGroups() {
      this.$emit('input', this.selectedGroups)
    },
    search: debounce(function () {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })
    }, 500),
  },
  async mounted() {
    await this.$nextTick()

    this.selectedGroups = this.selectedGroupUuids

    this.fetchMembershipGroups()
    this.$refs.recipientGroupContainer.onscroll= () =>  {
      let container = this.$refs.recipientGroupContainer

      if(!this.isLoading && container.scrollTop + container.clientHeight  >  (container.scrollHeight -20) && this.pagination.current_page < this.pagination.total_pages ) {
        this.isLoading = true
        this.fetchMembershipGroups({
          params: {
            query: this.search,
            page: this.pagination.current_page + 1,
          },
        }).then(() => this.isLoading = false)
      }
    }
  },
  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
    }),
    selectAll() {
      this.selectedGroups = _.map(this.membershipGroups, 'uuid')
    },
    selectNone() {
      this.selectedGroups = []
    },
  },
}
</script>

<style scoped>
.recipientFilter {
  margin-bottom: 0 !important;
}
</style>
